import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container sub_page _report" }
const _hoisted_2 = { class: "sub_page_tit" }
const _hoisted_3 = { class: "sub_menu_tab wrap_1120" }
const _hoisted_4 = { class: "sub_page_con wrap_1120 report_area" }
const _hoisted_5 = { class: "bread_crumbs" }
const _hoisted_6 = { class: "sub_con_banner" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "link con_list" }
const _hoisted_9 = {
  key: 0,
  class: "sub_page_con_view con_view"
}
const _hoisted_10 = { class: "tit_wrap" }
const _hoisted_11 = { class: "con_num" }
const _hoisted_12 = {
  class: "con_date",
  style: {"width":"180px"}
}
const _hoisted_13 = { class: "con_table_wrap" }
const _hoisted_14 = { class: "cate_wrap" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "areaContent" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "file_list_wrap" }
const _hoisted_20 = ["textContent"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "btn_wrap _default right_btn" }
const _hoisted_23 = {
  key: 1,
  class: "report_chk_wrap"
}
const _hoisted_24 = { class: "radio_wrap flex_half" }
const _hoisted_25 = {
  class: "input_wrap",
  style: {"display":"inline-flex"}
}
const _hoisted_26 = { for: "chk1_yes" }
const _hoisted_27 = ["checked"]
const _hoisted_28 = { for: "chk1_no" }
const _hoisted_29 = ["checked"]
const _hoisted_30 = { class: "flex_half" }
const _hoisted_31 = { class: "select_wrap _column" }
const _hoisted_32 = { class: "select_tab_box _board_type" }
const _hoisted_33 = { class: "tab_option" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "radio_wrap" }
const _hoisted_36 = { class: "select_wrap _column" }
const _hoisted_37 = { for: "chk2_yes" }
const _hoisted_38 = ["checked"]
const _hoisted_39 = {
  key: 0,
  class: "select_tab_box _board_type"
}
const _hoisted_40 = { class: "tab_option" }
const _hoisted_41 = {
  key: 1,
  class: "select_tab_box _board_type"
}
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 2 }
const _hoisted_45 = { class: "tab_option" }
const _hoisted_46 = {
  key: 2,
  class: "input_text_wrap"
}
const _hoisted_47 = { for: "chk2_no" }
const _hoisted_48 = ["checked"]
const _hoisted_49 = {
  key: 0,
  class: "select_tab_box _board_type"
}
const _hoisted_50 = {
  key: 0,
  class: "tab_option"
}
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "btn_wrap _default admin_save_btn right_btn" }
const _hoisted_53 = {
  key: 2,
  class: "reply_container"
}
const _hoisted_54 = { class: "reply_wrap admin_reply_wrap" }
const _hoisted_55 = {
  key: 0,
  class: "my_reply reply_box"
}
const _hoisted_56 = { class: "reply_date" }
const _hoisted_57 = {
  key: 0,
  class: "reply_btn"
}
const _hoisted_58 = ["onClick"]
const _hoisted_59 = ["onClick"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = ["innerHTML"]
const _hoisted_62 = { class: "replay_area_for_mobile" }
const _hoisted_63 = { class: "reply_area_right" }
const _hoisted_64 = { class: "reply_date" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["onClick"]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = {
  key: 0,
  style: {"width":"100%"}
}
const _hoisted_70 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _cache[32] || (_cache[32] = _createStaticVNode("<div class=\"deco_wrap\" data-v-735e5ec0><i class=\"deco_01\" data-v-735e5ec0><img src=\"img/report_left_01.png\" data-v-735e5ec0></i><i class=\"deco_02 spin_blink1 _small\" data-v-735e5ec0><img src=\"img/b_icon_03.png\" data-v-735e5ec0></i><i class=\"deco_03 blink_zoom1 _xxsmall\" data-v-735e5ec0><img src=\"img/b_icon_04.png\" data-v-735e5ec0></i><i class=\"deco_04 blink_blink4 _xxxsmall\" data-v-735e5ec0><img src=\"img/b_icon_04.png\" data-v-735e5ec0></i><i class=\"deco_05 spin2 _medium\" data-v-735e5ec0><img src=\"img/b_icon_03.png\" data-v-735e5ec0></i><i class=\"deco_06 spin_blink3 _small\" data-v-735e5ec0><img src=\"img/b_icon_01.png\" data-v-735e5ec0></i><i class=\"deco_07 blink_zoom4 _small\" data-v-735e5ec0><img src=\"img/b_icon_02.png\" data-v-735e5ec0></i><i class=\"deco_character\" data-v-735e5ec0><img src=\"img/report_icon.png\" data-v-735e5ec0></i></div><div class=\"banner_wrap wrap_1120\" data-v-735e5ec0><h2 data-v-735e5ec0>시민제보창</h2></div>", 2)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(["only_768", { active: $setup.state.subMenuOpen }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.subMenuTab && $setup.subMenuTab(...args)))
          }, _toDisplayString($setup.state.subMenuName), 3),
          _createElementVNode("ul", {
            class: _normalizeClass({ active: $setup.state.subMenuOpen })
          }, [
            _createElementVNode("li", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeTab(1))),
              class: "active"
            }, [...(_cache[30] || (_cache[30] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "성매매 의심 업소 제보", -1)
            ]))]),
            _createElementVNode("li", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeTab(2)))
            }, [...(_cache[31] || (_cache[31] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "성매매 알선 광고 제보", -1)
            ]))])
          ], 2)
        ])
      ]),
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "icon_wrap"
          }, {
            default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
              _createElementVNode("img", {
                src: "img/home_icon.png",
                alt: "홈"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _cache[35] || (_cache[35] = _createElementVNode("span", { class: "icon_wrap" }, [
            _createElementVNode("img", {
              src: "img/part_icon.png",
              alt: "성매매 의심 업소 제보"
            })
          ], -1)),
          _createVNode(_component_router_link, { to: { path: '/report', query: { type: 1 } } }, {
            default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
              _createTextVNode("성매매 의심 업소 제보", -1)
            ]))]),
            _: 1
          }),
          _cache[36] || (_cache[36] = _createElementVNode("span", { class: "icon_wrap" }, [
            _createElementVNode("img", {
              src: "img/part_icon.png",
              alt: "성매매 의심 업소 제보글"
            })
          ], -1)),
          _cache[37] || (_cache[37] = _createElementVNode("a", {
            href: "javascript:void(0)",
            style: {"cursor":"default"}
          }, "성매매 의심 업소 제보글", -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            innerHTML: $setup.CommonUtils.decodeContent($setup.state.menuContent)
          }, null, 8, _hoisted_7),
          _createElementVNode("div", _hoisted_8, [
            _cache[39] || (_cache[39] = _createElementVNode("p", null, "시민제보 처리과정이 궁금하신가요?", -1)),
            _createVNode(_component_router_link, {
              to: "/faqList",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.global.setIntroTab(3))),
              class: "action_btn"
            }, {
              default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                _createElementVNode("span", null, "과정 보러가기", -1),
                _createElementVNode("img", {
                  src: "img/move_btn.png",
                  alt: ""
                }, null, -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        (!$setup.state.isShowModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString($setup.state.data.idx), 1),
                _cache[40] || (_cache[40] = _createElementVNode("span", { class: "con_tit" }, "성매매 의심업소 제보", -1)),
                _createElementVNode("span", _hoisted_12, _toDisplayString($setup.CommonUtils.dateFormat(new Date($setup.state.data.createDate), ".", true)), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["cate", [$setup.state.data.state === 2 ? 'green' : '']])
                  }, _toDisplayString($setup.state.data.state === 1 ? "대기중" : "접수완료"), 3),
                  _createElementVNode("span", {
                    class: _normalizeClass(["cate", [$setup.state.data.isSchool === 1 ? 'red' : '']])
                  }, _toDisplayString($setup.state.data.isSchool === 1 ? "학교주변" : "의심업소"), 3)
                ]),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _cache[41] || (_cache[41] = _createElementVNode("div", { class: "con_th" }, "제보자 닉네임", -1)),
                    _createElementVNode("div", null, _toDisplayString($setup.state.data.nickname), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _cache[42] || (_cache[42] = _createElementVNode("div", { class: "con_th" }, "업소명", -1)),
                    _createElementVNode("div", null, _toDisplayString($setup.state.data.shopName), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _cache[43] || (_cache[43] = _createElementVNode("div", { class: "con_th" }, "업소주소", -1)),
                    _createElementVNode("div", null, _toDisplayString($setup.state.data.address) + " " + _toDisplayString($setup.state.data.addressDetail), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _cache[44] || (_cache[44] = _createElementVNode("div", { class: "con_th" }, "업소 전화번호", -1)),
                    _createElementVNode("div", null, _toDisplayString($setup.state.data.number), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _cache[45] || (_cache[45] = _createElementVNode("div", { class: "con_th" }, "업소 URL", -1)),
                    _createElementVNode("div", null, _toDisplayString($setup.state.data.adUrl), 1)
                  ]),
                  ($setup.state.data.isSchool === 1)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                        _cache[46] || (_cache[46] = _createElementVNode("div", { class: "con_th" }, "학교명", -1)),
                        _createElementVNode("div", null, _toDisplayString($setup.state.data.schoolName), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", _hoisted_16, [
                    _cache[47] || (_cache[47] = _createElementVNode("div", { class: "con_th" }, "내용", -1)),
                    _createElementVNode("div", {
                      class: "user_content",
                      innerHTML: $setup.state.data.content
                    }, null, 8, _hoisted_17)
                  ]),
                  ($setup.state.data.fileList != null && $setup.state.data.fileList.length > 0)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                        _cache[48] || (_cache[48] = _createElementVNode("div", { class: "con_th" }, "파일 다운로드", -1)),
                        _createElementVNode("div", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.data.fileList, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.idx,
                              class: _normalizeClass($setup.state.isMobile768 ? '_flex' : '')
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(!$setup.state.isMobile768 ? 'file_name' : 'file_name elips_1'),
                                textContent: _toDisplayString(item.imgRealName)
                              }, null, 10, _hoisted_20),
                              _createElementVNode("button", {
                                class: "common_style",
                                onClick: ($event: any) => ($setup.downloadFile(item.file, item.imgRealName))
                              }, "파일 다운로드", 8, _hoisted_21)
                            ], 2))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_22, [
          ($setup.state.data.state === 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "common_btn _gray",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.isDelete && $setup.isDelete(...args)))
              }, "삭제"))
            : _createCommentVNode("", true),
          ($setup.state.data.state === 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "common_btn",
                onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.router.push({ name: 'AreaModify', params: { id: $setup.state.idx } })))
              }, " 수정 "))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "common_btn",
            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.router.replace('/report?type=1')))
          }, "목록")
        ]),
        ($setup.state.hasAuth && !$setup.state.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _cache[53] || (_cache[53] = _createElementVNode("span", { class: "input_tit" }, "게시글 상태", -1)),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", _hoisted_26, [
                    _createElementVNode("input", {
                      type: "radio",
                      name: "chk1",
                      id: "chk1_yes",
                      checked: $setup.state.data.state === 1,
                      onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.state.data.state = 1))
                    }, null, 8, _hoisted_27),
                    _cache[49] || (_cache[49] = _createElementVNode("em", null, null, -1)),
                    _cache[50] || (_cache[50] = _createElementVNode("span", null, "대기중", -1))
                  ]),
                  _createElementVNode("label", _hoisted_28, [
                    _createElementVNode("input", {
                      type: "radio",
                      name: "chk1",
                      id: "chk1_no",
                      checked: $setup.state.data.state === 2,
                      onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.state.data.state = 2))
                    }, null, 8, _hoisted_29),
                    _cache[51] || (_cache[51] = _createElementVNode("em", null, null, -1)),
                    _cache[52] || (_cache[52] = _createElementVNode("span", null, "접수완료", -1))
                  ])
                ])
              ]),
              ($setup.state.data.state === 2)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_30, [
                      _cache[54] || (_cache[54] = _createElementVNode("span", { class: "input_tit" }, "업종분류", -1)),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["selected_tab", [$setup.state.isActive ? 'active' : '']]),
                            onClick: _cache[9] || (_cache[9] = ($event: any) => {
                                        $setup.state.isActive = !$setup.state.isActive;
                                        ($setup.state.isPossible = false), ($setup.state.isPossible2 = false), ($setup.state.isReason = false);
                                    })
                          }, [
                            _createElementVNode("span", null, _toDisplayString($setup.state.category.find((c) => c.caIdx === $setup.state.data.gubun)?.caName), 1)
                          ], 2),
                          _createElementVNode("div", _hoisted_33, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.category, (item) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: item.caIdx,
                                onClick: ($event: any) => {
                                            $setup.state.data.gubun = item.caIdx;
                                            $setup.state.isActive = false;
                                        },
                                class: _normalizeClass([$setup.state.data.gubun === item ? 'active' : ''])
                              }, _toDisplayString(item.caName), 11, _hoisted_34))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _cache[59] || (_cache[59] = _createElementVNode("span", { class: "input_tit" }, "고발/ 신고여부", -1)),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_37, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "chk2",
                              id: "chk2_yes",
                              checked: $setup.state.data.isReport === 1,
                              onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.state.data.isReport = 1))
                            }, null, 8, _hoisted_38),
                            _cache[55] || (_cache[55] = _createElementVNode("em", null, null, -1)),
                            _cache[56] || (_cache[56] = _createElementVNode("span", null, "가능", -1))
                          ]),
                          ($setup.state.data.isReport === 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["selected_tab", [$setup.state.isPossible ? 'active' : '']]),
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => {
                                            $setup.state.isPossible = !$setup.state.isPossible;
                                            ($setup.state.isActive = false), ($setup.state.isPossible2 = false), ($setup.state.isReason = false);
                                        })
                                }, [
                                  _createElementVNode("span", null, _toDisplayString($setup.state.data.reportState === 2 ? "고발" : "신고"), 1)
                                ], 2),
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("button", {
                                    onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.selectReportState(1)))
                                  }, "신고"),
                                  _createElementVNode("button", {
                                    onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.selectReportState(2)))
                                  }, "고발")
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          ($setup.state.data.isReport === 1 && $setup.state.data.reportState === 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["selected_tab", [$setup.state.isPossible2 ? 'active' : '']]),
                                  onClick: _cache[14] || (_cache[14] = ($event: any) => {
                                            $setup.state.isPossible2 = !$setup.state.isPossible2;
                                            ($setup.state.isActive = false), ($setup.state.isPossible = false), ($setup.state.isReason = false);
                                        })
                                }, [
                                  ($setup.state.data.reportType === 1)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_42, "국민신문고"))
                                    : ($setup.state.data.reportType === 2)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_43, "방통위"))
                                      : ($setup.state.data.reportType === 3)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_44, "기타"))
                                        : _createCommentVNode("", true)
                                ], 2),
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("button", {
                                    onClick: _cache[15] || (_cache[15] = ($event: any) => {
                                                $setup.state.isPossible2 = false;
                                                $setup.state.data.reportType = 1;
                                            })
                                  }, " 국민신문고 "),
                                  _createElementVNode("button", {
                                    onClick: _cache[16] || (_cache[16] = ($event: any) => {
                                                $setup.state.isPossible2 = false;
                                                $setup.state.data.reportType = 2;
                                            })
                                  }, " 방통위 "),
                                  _createElementVNode("button", {
                                    onClick: _cache[17] || (_cache[17] = ($event: any) => {
                                                $setup.state.isPossible2 = false;
                                                $setup.state.data.reportType = 3;
                                            })
                                  }, " 기타 ")
                                ])
                              ]))
                            : ($setup.state.data.isReport === 1 && $setup.state.data.reportState === 2)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                  _withDirectives(_createElementVNode("input", {
                                    name: "reportState",
                                    type: "text",
                                    placeholder: "고발 사유를 입력해주세요.",
                                    class: "custom_input",
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (($setup.state.data.reportMemo) = $event))
                                  }, null, 512), [
                                    [_vModelText, $setup.state.data.reportMemo]
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_47, [
                            _createElementVNode("input", {
                              type: "radio",
                              name: "chk2",
                              id: "chk2_no",
                              checked: $setup.state.data.isReport === 2,
                              onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.state.data.isReport = 2))
                            }, null, 8, _hoisted_48),
                            _cache[57] || (_cache[57] = _createElementVNode("em", null, null, -1)),
                            _cache[58] || (_cache[58] = _createElementVNode("span", null, "불가능", -1))
                          ]),
                          ($setup.state.data.isReport === 2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["selected_tab", [$setup.state.isReason ? 'active' : '']]),
                                  onClick: _cache[20] || (_cache[20] = ($event: any) => {
                                            $setup.state.isReason = !$setup.state.isReason;
                                            ($setup.state.isActive = false), ($setup.state.isPossible = false), ($setup.state.isPossible2 = false);
                                        })
                                }, [
                                  _createElementVNode("span", null, _toDisplayString($setup.currentReason), 1)
                                ], 2),
                                ($setup.state.isReason)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.reasons, (label, idx) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                          key: idx,
                                          onClick: ($event: any) => ($setup.selectReason(idx + 1)),
                                          class: _normalizeClass({ active: ($setup.state.data.reason || 1) === idx + 1 })
                                        }, _toDisplayString(label), 11, _hoisted_51))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("textarea", {
                  class: "custom_scroll light_gray",
                  placeholder: "메모",
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (($setup.state.data.memo) = $event))
                }, null, 512), [
                  [_vModelText, $setup.state.data.memo]
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => ($setup.stateSave && $setup.stateSave(...args))),
                  class: "common_btn"
                }, "저장")
              ])
            ]))
          : _createCommentVNode("", true),
        ($setup.state.hasAuth || $setup.state.comments.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                ($setup.state.hasAuth)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      _cache[61] || (_cache[61] = _createElementVNode("div", { class: "reply_writer" }, [
                        _createElementVNode("img", {
                          src: "img/symbol.png",
                          alt: ""
                        }),
                        _createTextVNode(" 다시함께상담센터 ")
                      ], -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        textarea: "",
                        name: "",
                        id: "",
                        class: "reply_con custom_scroll",
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (($setup.form_state.commentContent) = $event))
                      }, null, 512), [
                        [_vModelText, $setup.form_state.commentContent]
                      ]),
                      _createElementVNode("button", {
                        class: "reply_submit",
                        alt: "댓글 등록",
                        onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => ($setup.commentAdd && $setup.commentAdd(...args)))
                      }, [...(_cache[60] || (_cache[60] = [
                        _createElementVNode("img", {
                          src: "img/reply_uoload.png",
                          alt: ""
                        }, null, -1)
                      ]))])
                    ]))
                  : _createCommentVNode("", true),
                ($setup.state.comments.length > 0)
                  ? (_openBlock(), _createElementBlock("ul", {
                      key: 1,
                      class: _normalizeClass(["", [$setup.state.hasAuth ? 'replies' : '']])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.comments, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "reply_box",
                          key: index
                        }, [
                          (!$setup.state.isMobile)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _cache[62] || (_cache[62] = _createElementVNode("div", { class: "reply_writer" }, [
                                  _createElementVNode("img", {
                                    src: "img/symbol.png",
                                    alt: ""
                                  }),
                                  _createElementVNode("span", null, "다시함께상담센터")
                                ], -1)),
                                _createElementVNode("div", _hoisted_56, _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.createDate), ".", true)), 1),
                                ($setup.state.hasAuth)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                      ($setup.comment_state.idx !== item.idx)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("button", {
                                              type: "button",
                                              onClick: ($event: any) => ($setup.commentModify(item))
                                            }, "수정", 8, _hoisted_58),
                                            _createElementVNode("button", {
                                              type: "button",
                                              onClick: ($event: any) => ($setup.confirmCommentRemove(item.idx)),
                                              class: "_gray"
                                            }, "삭제", 8, _hoisted_59)
                                          ], 64))
                                        : ($setup.comment_state.mode === 'modify' && $setup.comment_state.idx === item.idx)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createElementVNode("button", {
                                                type: "button",
                                                onClick: ($event: any) => ($setup.commentSave(item))
                                              }, "저장", 8, _hoisted_60),
                                              _createElementVNode("button", {
                                                type: "button",
                                                onClick: _cache[25] || (_cache[25] = ($event: any) => ($setup.commentCancel())),
                                                class: "_gray"
                                              }, "취소")
                                            ], 64))
                                          : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                ($setup.comment_state.idx !== item.idx)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: "reply_con",
                                      innerHTML: item.content.replaceAll('\n', '<br>')
                                    }, null, 8, _hoisted_61))
                                  : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                      key: 2,
                                      class: "reply_con",
                                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (($setup.comment_state.content) = $event))
                                    }, null, 512)), [
                                      [_vModelText, $setup.comment_state.content]
                                    ])
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("div", _hoisted_62, [
                                  _cache[64] || (_cache[64] = _createElementVNode("div", { class: "reply_writer" }, [
                                    _createElementVNode("img", {
                                      src: "img/symbol.png",
                                      alt: ""
                                    }),
                                    _createElementVNode("span", null, "다시함께상담센터")
                                  ], -1)),
                                  _createElementVNode("div", _hoisted_63, [
                                    _createElementVNode("div", _hoisted_64, _toDisplayString($setup.CommonUtils.dateFormat(new Date(item.createDate), ".", true)), 1),
                                    ($setup.state.hasAuth)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          onClick: ($event: any) => ($setup.edit(item)),
                                          style: {"margin-left":"10px"}
                                        }, [...(_cache[63] || (_cache[63] = [
                                          _createElementVNode("img", {
                                            src: "img/kebabIcon.png",
                                            style: {"height":"18px","width":"auto"}
                                          }, null, -1)
                                        ]))], 8, _hoisted_65))
                                      : _createCommentVNode("", true),
                                    _withDirectives(_createElementVNode("div", {
                                      class: _normalizeClass(["reply_btn", $setup.state.isShowBtn && $setup.comment_state.idx === item.idx ? '_mobile' : ''])
                                    }, [
                                      ($setup.comment_state.mode !== 'modify' && $setup.comment_state.idx === item.idx)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("button", {
                                              type: "button",
                                              onClick: ($event: any) => ($setup.commentModify(item))
                                            }, "수정", 8, _hoisted_66),
                                            _createElementVNode("button", {
                                              type: "button",
                                              onClick: ($event: any) => ($setup.confirmCommentRemove(item.idx)),
                                              class: "_gray"
                                            }, "삭제", 8, _hoisted_67)
                                          ], 64))
                                        : ($setup.comment_state.mode === 'modify' && $setup.comment_state.idx === item.idx)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                              _createElementVNode("button", {
                                                type: "button",
                                                onClick: ($event: any) => ($setup.commentSave(item))
                                              }, "저장", 8, _hoisted_68),
                                              _createElementVNode("button", {
                                                type: "button",
                                                onClick: _cache[27] || (_cache[27] = ($event: any) => ($setup.commentCancel())),
                                                class: "_gray"
                                              }, "취소")
                                            ], 64))
                                          : _createCommentVNode("", true)
                                    ], 2), [
                                      [_vShow, $setup.state.isShowBtn && $setup.comment_state.idx === item.idx]
                                    ])
                                  ])
                                ]),
                                ($setup.comment_state.mode === 'modify' && $setup.comment_state.idx === item.idx)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "password",
                                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (($setup.comment_state.pw) = $event)),
                                        placeholder: "비밀번호를 입력해주세요."
                                      }, null, 512), [
                                        [_vModelText, $setup.comment_state.pw]
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (($setup.comment_state.mode !== 'modify' && $setup.comment_state.idx === item.idx) || $setup.comment_state.idx !== item.idx)
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: "reply_con",
                                      innerHTML: item.content.replaceAll('\n', '<br>')
                                    }, null, 8, _hoisted_70))
                                  : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                      key: 2,
                                      class: "reply_con",
                                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (($setup.comment_state.content) = $event))
                                    }, null, 512)), [
                                      [_vModelText, $setup.comment_state.content]
                                    ])
                              ], 64))
                        ]))
                      }), 128))
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Footer)
  ], 64))
}